module.exports = __webpack_public_path__ + "static/drone-3x-d13bcf09994d95fd9491a9b9036da13a.webp";